import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import { ChartPlaceholder } from './CardViews/CardViews';

import chartUtils from '../util/chartUtils';
export default function CardPlaceholder({ title, shape, loading, onClose }) {
  const isTable = shape === 'table';
  return (
    <div className={`box_white_shadow ${isTable ? 'table_metrics' : 'chart_averages_box'}`}>
      <div className="box_white_title">
        <h3>{title}</h3>
        {onClose && (
          <div className="right-actions">
            <Button className="btn-action" onClick={onClose} aria-label="Hide this card" title="Hide this card">&times;</Button>
          </div>
        )}
      </div>
      <ChartPlaceholder shape={shape} loading={loading} />
    </div>
  );
}

CardPlaceholder.propTypes = {
  title: PropTypes.string,
  shape: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func
};
